(function(){
    angular
        .module('appback')
        .directive('stringToInt', stringToInt);

        stringToInt.$inject = ['$timeout'];
        function stringToInt($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
			      ngModel.$parsers.push(function(value) {
			      	//console.log(typeof(value));
			      	//console.log(value);
			      	//console.log(!isNaN(value));
			      	if(typeof(value)!='undefined' && value != null && !isNaN(value) && value!=''){
			        	return '' + value;
			        }else{
			        	return '';
			        }
			      });
			      ngModel.$formatters.push(function(value) {
			      				      	//console.log(typeof(value));
			      	//console.log(value);
			      	//console.log(!isNaN(value));
			      	//console.log(value+'b');
			      	if(typeof(value)!='undefined' && value != null && !isNaN(value) && value!=''){
			      		//console.log(value);
			      		//console.log("AS");
			      		//console.log(''+parseInt(value));
				        return ''+parseInt(value);
				    }else{
				    	if(value===0){
			      	//console.log(value);
				        	return '0';
				    	}else{
					    	return '';
					    }
				    }
			      });
				}
        	}
        }
})();